module.exports = __webpack_public_path__ + "static/media/organise.23a00576.png";